import { render, staticRenderFns } from "./longText.vue?vue&type=template&id=0cdb23ac&scoped=true"
import script from "./longText.vue?vue&type=script&lang=js"
export * from "./longText.vue?vue&type=script&lang=js"
import style0 from "./longText.vue?vue&type=style&index=0&id=0cdb23ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb23ac",
  null
  
)

export default component.exports